'use es6';

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UIList from 'UIComponents/list/UIList';
var MAX_LIST_ITEMS = 4;

var ThemeAssets = function ThemeAssets(_ref) {
  var abbreviateList = _ref.abbreviateList,
      assetNamesBySubType = _ref.assetNamesBySubType,
      showHeader = _ref.showHeader;
  // TODO use packCounts.subTypes translations for now
  var renderedCounts = useMemo(function () {
    var counts = assetNamesBySubType.map(function (value, key) {
      return React.createElement(FormattedMessage, {
        key: key,
        message: "marketplacelib.packCounts.subTypes." + key,
        options: {
          count: value.size
        }
      });
    }).toArray();
    return abbreviateList ? counts.slice(0, MAX_LIST_ITEMS) : counts;
  }, [abbreviateList, assetNamesBySubType]);
  var renderedOverflowText = useMemo(function () {
    if (!abbreviateList) {
      return null;
    }

    var count = assetNamesBySubType.slice(MAX_LIST_ITEMS).reduce(function (final, current) {
      return final + current.size;
    }, 0);
    return count ? React.createElement(FormattedMessage, {
      message: "marketplacelib.themeAssets.overflowText",
      options: {
        count: count
      }
    }) : null;
  }, [abbreviateList, assetNamesBySubType]);
  return React.createElement("div", null, showHeader && React.createElement(H5, null, React.createElement(FormattedMessage, {
    message: "marketplacelib.themeAssets.title"
  })), React.createElement(UIList, {
    styled: true,
    className: "p-left-5"
  }, renderedCounts), renderedOverflowText);
};

ThemeAssets.propTypes = {
  abbreviateList: PropTypes.bool,
  assetNamesBySubType: PropTypes.instanceOf(Immutable.Map),
  showHeader: PropTypes.bool
};
ThemeAssets.defaultProps = {
  abbreviateList: false,
  assetNamesBySubType: Immutable.Map(),
  showHeader: false
};
export default ThemeAssets;